<template>
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <!-- Invocacion de componente settings -->
      <settings
        :settings="currentResource"
        :menuId="currentMenu.id"
        :menu="currentMenu"
        :isnivel3="isnivel3"
        :dialogFlag="editResourceDialogFlag"
        @closeResourceDialogEvent="closeResourceDialog()"
        @reloadLocationsEvent="reLoadData()"
      />
      <!-- modal con formulario para la creacion de nuevo atributo -->
      <v-dialog persistent v-model="newDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("tblbutton")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="newForm" lazy-validation>
                <v-row>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-text-field v-model="currentatributtes.name" :label="$t('lblNombre')"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-autocomplete
                      v-model="selected"
                      :label="$t('lbloptions')"
                      :items="checkbox_options"
                    ></v-autocomplete>
                    <!-- <strong>{{ selected }}</strong> -->
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0" v-show="$route.params.idMenu !=4">
                    <!-- {{$route.params.idMenu }} -- {{idMenu}} -->
                    <v-autocomplete
                      v-model="currentatributtes.resourceTypeId"
                      :label="$t('lblContent')"
                      :items="$route.params.idMenu == 3 && selected != idMenu  || $route.params.idMenu == 2 && selected != idMenu ? options_content3 : isnivel3 == true ? options_content2 :  options_content "
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" class="pa-0 ma-0">
                    <v-text-field v-model="currentatributtes.posicion" :label="$t('lblPosition')"></v-text-field>
                  </v-col>

                  <v-col class="pa-0 ma-0" cols="12">
                    <v-file-input
                      show-size
                      hint="Icono"
                      persistent-hint
                      prepend-icon
                      v-model="files"
                      append-icon="mdi-folder-search"
                      v-on:change="handleFileUploadIco"
                    />
                  </v-col>
                  <v-col
                    class="pa-0 ma-0"
                    cols="12"
                    v-show="$route.params.idMenu !=4"
                    v-if="currentatributtes.resourceTypeId == 1 || currentatributtes.resourceTypeId == 2   || currentatributtes.resourceTypeId == 9"
                  >
                    <v-file-input
                      show-size
                      :hint="$t('lblResources')"
                      persistent-hint
                      prepend-icon
                      v-model="files2"
                      append-icon="mdi-folder-search"
                      v-on:change="handleFileUpload"
                    />
                  </v-col>
                  <v-row v-else v-show="$route.params.idMenu !=4">
                    <v-col
                      cols="12"
                      class="pa-0 ma-0 pl-3 pr-3"
                      v-if=" currentatributtes.resourceTypeId == 3 || currentatributtes.resourceTypeId == 10 || currentatributtes.resourceTypeId == 13 || currentatributtes.resourceTypeId == 14"
                    ></v-col>
                    <v-col v-else cols="12" class="pa-0 ma-0 pl-3 pr-3">
                      <v-text-field
                        v-model="currentatributtes.fileName"
                        :label="$t('lblResources')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-col cols="12" center v-if="progress > 0">
                    <v-progress-linear v-model="progress" height="25" reactive>
                      <strong>{{ progress }}%</strong>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeNewDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doNewDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- modal con formulario para la creacion de nuevo atributo -->
      <v-dialog persistent v-model="editDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("tblbutton")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="newForm" lazy-validation>
                <v-row>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-text-field v-model="currentatributtes.name" :label="$t('lblNombre')"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-autocomplete
                      v-model="currentatributtes.optionPadre"
                      :label="$t('lbloptions')"
                      :items="checkbox_options"
                    ></v-autocomplete>
                    <!-- <strong>{{ selected }}</strong> -->
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-text-field v-model="currentatributtes.position" :label="$t('lblPosition')"></v-text-field>
                  </v-col>
                  <!-- add - option edit tipo de contenido  -->
                   <v-col cols="12" class="pa-0 ma-0" v-show="selected !=4">
                    <v-autocomplete
                      v-model="currentatributtes.typeContent"
                      :label="$t('lblContent')"
                      :items="selected == 3 || selected == 2 ?options_content2:options_content"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeEditDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doEditDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-text-field
        solo
        dense
        outlined
        class="mt-4"
        :label="$t('headerSearch')"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="menu"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
        v-if="editResourceDialogFlag === false"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('tblTitle', { menuName: nameMenu })}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <!-- <v-select v-model="filter" :items="type_menu" attach></v-select> -->
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ma-2" @click.stop="newDialog = true">{{$t('tblbutton')}}</v-btn>
          </v-toolbar>
        </template>
        <!-- Panel de estado -->
        <template v-slot:item.children="{ item }">
          <v-col v-if="item.children > 0">
            <v-btn icon color="primary" @click="submenu(item)">
              <v-icon>mdi-table-column-plus-after</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn icon color="secundary">
              <v-icon>mdi-table-column-plus-after</v-icon>
            </v-btn>
          </v-col>
        </template>
        <template v-slot:item.id="{ item }">
          <v-col v-if="$route.params.idMenu !=4">
            <v-btn icon color="primary" @click="editResource(item)">
              <v-icon>mdi-archive</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>NO APLICA</v-col>
        </template>
        <template v-slot:item.active="{ item }">
          <v-col v-if="item.active === 1">
            <v-btn icon color="primary" @click="statusItem(item)">
              <v-icon>mdi-thumb-up</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn icon color="grey" @click="statusItem(item)">
              <v-icon>mdi-thumb-down</v-icon>
            </v-btn>
          </v-col>
        </template>
        <!-- Panel de acciones -->
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblEdit')}}</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <!-- Tabla de contenido -->

      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
// Incluimos el LAYOUT estandar para los usuario que ya tienen
// una sesión activa
import Layout from "@/components/Layouts/company";
// Incluimos los mensajes de esta pantalla
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import Settings from "./settings/index";
import _ from "lodash";
import uuid from "uuid4";

const DEFULT_SETTINGS = [];
const DEFULT_LOCATION = { id: 0 };
let BASE_URL_FOR_PHOTOS = "content/menu/resources/";
let DEFAULT_FILE_MODEL = { isValid: false, contentData: null };
let DEFAULTF_CURRENT_ATRIBUTE = {
  resourceTypeId: 0,
  SecondResourceTypeId: 0,
  fileName: "",
};
export default {
  // Se definen los componentes requeridos por esta pantalla
  components: {
    layout: Layout,
    settings: Settings,
  },
  created() {
    this.$i18n.locale = this.locale;
    // Obtenemos la lista de ubicaciones
    this.loadData();
    //inicializamos encabezados de la tabla
    this.updateHeadersLocale();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function () {
    return {
      currentResource: DEFULT_SETTINGS,
      editResourceDialogFlag: false,
      currentMenu: DEFULT_LOCATION,
      idMenu: this.$route.params.idMenu,
      nameMenu: this.$route.params.name,
      newDialog: false,
      editDialog: false,
      snackbar: false,
      mensaje: "",
      search: "",
      selected: this.$route.params.idMenu,
      checkbox_options: [],
      filter: 0,
      isnivel3: null,
      menu: [],
      // archivos
      files: [],
      progress: 0,
      currentFile: DEFAULT_FILE_MODEL,
      currentFileIcon: DEFAULT_FILE_MODEL,
      type_menu: [
        { value: 1, text: "PORTAL WEB" },
        { value: 2, text: "APLICACIÓN MOVIL" },
      ],
      options_content: [
        { value: 1, text: "PDF" },
        { value: 2, text: "IMAGE (Estática, PNG, JPG, GIF)" },
        { value: 3, text: "Submenu" },
        { value: 4, text: "URL (Externa)" },
        { value: 5, text: "VIDEO (Youtube) " },
        { value: 6, text: "VIDEO (Facebook) " },
        { value: 7, text: "VIDEO (Vimeo) " },
        {
          value: 8,
          text: "VIDEO (URL, se abré en un webview embebido en la app)",
        },
        { value: 9, text: "Mapa (PNG) " },
        { value: 10, text: "Timeline Fav " },
        { value: 11, text: "Timeline" },
        { value: 12, text: "Timeline + Fav " },
        { value: 13, text: "Toolbox " },
        { value: 14, text: "Favoritos" },
        { value: 15, text: "URL Embebida (webview) " },
        { value: 16, text: "LikendIn " },
        { value: 17, text: "Facebook " },
        { value: 18, text: "Instagram" },
        { value: 19, text: "Twitter" },
        { value: 20, text: "YouTube Channel" },
        { value: 99, text: "HTML" },
        { value: 100, text: "Nativa" },
        { value: 101, text: "iOS/StoryBoard" },
        { value: 102, text: "iOS/Controller" },
        { value: 103, text: "Android/Activity" },
        { value: 104, text: "IdParam" },
        { value: 127, text: "IDNATIVE" },
        { value: 126, text: "LINK" },
      ],
      options_content2: [
        { value: 10, text: "Timeline Fav " },
        { value: 13, text: "Toolbox " },
        { value: 14, text: "Favoritos" },
      ],
      options_content3: [
        { value: 1, text: "PDF" },
        { value: 2, text: "IMAGE (Estática, PNG, JPG, GIF)" },
        { value: 3, text: "Submenu" },
        { value: 4, text: "URL (Externa)" },
        { value: 5, text: "VIDEO (Youtube) " },
        { value: 6, text: "VIDEO (Facebook) " },
        { value: 7, text: "VIDEO (Vimeo) " },
        {
          value: 8,
          text: "VIDEO (URL, se abré en un webview embebido en la app)",
        },
        { value: 9, text: "Mapa (PNG) " },
        { value: 11, text: "Timeline" },
        { value: 12, text: "Timeline + Fav " },
        { value: 15, text: "URL Embebida (webview) " },
        { value: 16, text: "LikendIn " },
        { value: 17, text: "Facebook " },
        { value: 18, text: "Instagram" },
        { value: 19, text: "Twitter" },
        { value: 20, text: "YouTube Channel" },
        { value: 99, text: "HTML" },
        { value: 100, text: "Nativa" },
        { value: 101, text: "iOS/StoryBoard" },
        { value: 102, text: "iOS/Controller" },
        { value: 103, text: "Android/Activity" },
        { value: 104, text: "IdParam" },
        { value: 127, text: "IDNATIVE" },
        { value: 126, text: "LINK" },
      ],
      //encabezados de la tabla
      headers: [
        { id: "header1Name", text: "Nombre", value: "name" },
        { id: "header1Posicion", text: "Posición", value: "position" },
        { id: "header1Jerarquia", text: "Jerarquía", value: "children" },
        { id: "header1Type", text: "Tipo de contenido", value: "id" },
        { id: "header1Activo", text: "Estado", value: "active" },
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false,
        },
      ],
      currentatributtes: DEFAULTF_CURRENT_ATRIBUTE,
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    },
    filter() {
      this.loadData();
    },
    idMenu() {
      this.loadData();
    },
  },
  methods: {
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map((header) => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    loadOptions() {
      let data = {
        itemId: this.idMenu,
      };
      return this.$GET("/api/menu/{{itemId}}/options", data)
        .then((menu) => {
          this.menu = menu;
        })
        .catch(() => {
          //** console.log(e)
        });
    },
    //consulta de ubicaciones desde lambda, asignacion de datos a arreglo locations
    loadData() {
      let data = {
        itemId: this.idMenu,
      };
      return this.$GET("/api/menu/{{itemId}}/options", data)
        .then((menu) => {
          this.checkbox_options = menu.map((response) => {
            response.optionPadre == 3 || response.optionPadre == 2
              ? (this.isnivel3 = true)
              : (this.isnivel3 = false);
            return {
              value: response.id,
              text: response.name,
            };
          });
          this.checkbox_options.push({
            value: this.idMenu,
            text: this.nameMenu,
          });
          this.loadOptions();
          //this.menu = menu;
          //console.log(menu);
        })
        .catch(() => {
          //** console.log(e)
        });
    },
    reLoadData() {
      this.loadData();
    },
    editResource(item) {
      this.currentMenu = _.clone(item);
      //console.log("currentMenu",this.currentMenu );
      this.loadResource(item.id);
      this.editResourceDialogFlag = true;
    },
    loadResource(id) {
      let data = {
        itemId: id,
      };
      console.log("/api/screenSettings/resources/{{itemId}}", data);
      return this.$GET("/api/screenSettings/resources/{{itemId}}", data)
        .then((resource) => {
          this.currentResource = resource.resources;
          /* this.currentResource.push({
          content: resource.icon, resourceTypeId: 2
        }); */
          console.log("this.currentResource", this.currentResource);
          return this.resource;
          //console.log(menu);
        })
        .catch(() => {
          //** console.log(e)
        });
    },
    //
    closeResourceDialog() {
      this.currentMenu = DEFULT_LOCATION;
      this.currentResource = DEFULT_SETTINGS;
      this.editResourceDialogFlag = false;
      this.currentFile = {};
      this.currentatributtes = {};
      this.progress = 0;
      this.files = [];
    },
    doNewDialog() {
      if (
        this.currentatributtes.name == null ||
        this.currentatributtes.name == ""
      ) {
        this.snackbar = true;
        this.mensaje = this.$t("lblValidation2");
      } else if (
        this.currentatributtes.resourceTypeId == 11 &&
        this.selected != this.idMenu
      ) {
        this.snackbar = true;
        this.mensaje =
          "Los recursos tipo Timeline Fav no pueden tenr atributos Hijo";
      } else if (
        this.currentatributtes.posicion == null ||
        this.currentatributtes.posicion == ""
      ) {
        this.snackbar = true;
        this.mensaje = this.$t("lblValidation3");
      } else {
        if (
          this.currentatributtes.resourceTypeId == 1 ||
          this.currentatributtes.resourceTypeId == 2 ||
          this.currentatributtes.resourceTypeId == 9
        ) {
          this.doUploadPhoto((path) => {
            console.log("=================== PATH ======================");
            console.log("path", path);
            console.log("=================== ++++ ======================");

            let payload = {
              data: {
                option: 0,
                optionPadre:
                  this.selected == null ? this.idMenu : this.selected,
                perfil: 1,
                name: this.currentatributtes.name,
                position: this.currentatributtes.posicion,
                typeContent: this.currentatributtes.resourceTypeId,
                active: 0,
                children: 0,
                update: 0,
                resource: {
                  resourceTypeId: this.currentatributtes.resourceTypeId,
                  content: path.replace("content/", ""),
                },
              },
            };
            console.log("/api/screenSettings/setOption", payload);
            this.$POST("/api/screenSettings/setOption", payload)
              .then((response) => {
                this.doUploadIco((path) => {
                  console.log(
                    "=================== PATH ======================"
                  );
                  console.log("path", path);
                  console.log(
                    "=================== ++++ ======================"
                  );

                  let payload = {
                    data: {
                      type: 2,
                      content: path.replace("content/", ""),
                      optionId: response.optionId,
                    },
                  };
                  console.log("/api/screenSettings/setResources", payload);
                  this.$POST("/api/screenSettings/setResources", payload)
                    .then(() => {
                      this.closeNewDialog();
                    })
                    .catch((e) => {
                      console.log("error con endpint", e);
                    })
                    .finally(() => {
                      this.closeNewDialog();
                    });
                });
                this.closeNewDialog();
                this.newDialog = false;
                this.loadData();
              })
              .catch((e) => {
                console.log("error con endpint", e);
              })
              .finally(() => {
                this.closeNewDialog();
                this.newDialog = false;
              });
          });
        } else {
          let payload = {
            data: {
              option: 0,
              optionPadre: this.selected == null ? this.idMenu : this.selected,
              perfil: 1,
              name: this.currentatributtes.name,
              position: this.currentatributtes.posicion,
              typeContent: this.currentatributtes.resourceTypeId,
              active: 0,
              children: 0,
              update: 0,
              resource: {
                resourceTypeId: this.currentatributtes.resourceTypeId,
                content: this.currentatributtes.fileName,
              },
            },
          };
          console.log("/api/screenSettings/setOption", payload);
          this.$POST("/api/screenSettings/setOption", payload)
            .then((response) => {
              this.doUploadIco((path) => {
                  console.log(
                    "=================== PATH ======================"
                  );
                  console.log("path", path);
                  console.log(
                    "=================== ++++ ======================"
                  );

                  let payload = {
                    data: {
                      type: 2,
                      content: path.replace("content/", ""),
                      optionId: response.optionId,
                    },
                  };
                  console.log("/api/screenSettings/setResources", payload);
                  this.$POST("/api/screenSettings/setResources", payload)
                    .then(() => {
                       this.closeNewDialog();
              this.newDialog = false;
              this.loadData();
                    })
                    .catch((e) => {
                      console.log("error con endpint", e);
                    })
                    .finally(() => {
                      this.closeNewDialog();
                    });
                });
              this.closeNewDialog();
              this.newDialog = false;
              this.loadData();
            })
            .catch((e) => {
              console.log("error con endpint", e);
            })
            .finally(() => {
              this.closeNewDialog();
              this.newDialog = false;
            });
        }
      }
    },
    doEditDialog() {
      if (
        this.currentatributtes.name == null ||
        this.currentatributtes.name == ""
      ) {
        this.snackbar = true;
        this.mensaje = this.$t("lblValidation2");
      } else {
        let payload = {
          data: {
            option: this.currentatributtes.id,
            optionPadre: this.currentatributtes.optionPadre,
            perfil: this.currentatributtes.perfil,
            name: this.currentatributtes.name,
            
            position:
              this.currentatributtes.position == null ||
              this.currentatributtes.position == ""
                ? 0
                : this.currentatributtes.position,
            typeContent: this.currentatributtes.typeContent,
            active: this.currentatributtes.active,
            date: this.currentatributtes.date,
          },
        };
        console.log("/api/menu/update/options", payload);
        this.$POST("/api/menu/update/options", payload)
          .then(() => {
            this.closeEditDialog();
            this.editDialog = false;
            this.loadData();
          })
          .catch((e) => {
            console.log("error con endpint", e);
          });
      }
    },
    closeNewDialog() {
      this.newDialog = false;
      //this.$refs.newForm.reset();
      this.selected = null;
      this.currentatributtes = {};
      this.progress = 0;
      this.currentFile = {};
      this.currentatributtes = {};
      this.progress = 0;
      this.files = [];
    },
    closeEditDialog() {
      this.editDialog = false;
      this.currentatributtes = {};
      this.progress = 0;
    },
    editItem(item) {
      this.currentatributtes = item;
      console.log("this.currentatributtes", this.currentatributtes);
      this.editDialog = true;
    },
    submenu(item) {
      this.idMenu = item.id;
      this.nameMenu = item.name;
      this.selected = item.id;
    },
    statusItem(item) {
      let payload = {
        data: {
          option: item.id,
          optionPadre: item.optionPadre,
          perfil: item.perfil,
          name: item.name,
          position: item.position,
          typeContent: item.typeContent,
          active: item.active == 0 ? 1 : 0,
          date: item.date,
        },
      };
      console.log("/api/menu/update/options", payload);
      this.$POST("/api/menu/update/options", payload)
        .then(() => {
          this.loadData();
        })
        .catch((e) => {
          console.log("error con endpint", e);
        });
    },
    // Manejador del archivo
    handleFileUpload(currentFile) {
      let self = this;
      if (!currentFile || currentFile.length === 0) {
        this.currentFile = null;
      } else {
        self.$store.dispatch("initLoader");
        self.currentFile = currentFile;
        self.currentFile.isValid = false;
        self.currentFile.contentData = null;
        self.errorMessage = "";
        let format = self.currentFile.type.split("/");
        let reader = new FileReader();
        reader.onload = function (e) {
          try {
            let data = new Uint8Array(e.target.result);
            self.currentFile.contentData = data;
            self.currentFile.isValid = true;
            self.currentFile.format = format[1];
          } catch (error) {
            window.self.errorMessage = error.message; //** console.log(error);
          } finally {
            self.$store.dispatch("stopLoader");
          }
        };
        reader.readAsArrayBuffer(self.currentFile);
        console.log("currentFile", self.currentFile);
      }
    },
    handleFileUploadIco(currentFile) {
      let self = this;
      if (!currentFile || currentFile.length === 0) {
        this.currentFile = null;
      } else {
        self.$store.dispatch("initLoader");
        self.currentFileIcon = currentFile;
        self.currentFileIcon.isValid = false;
        self.currentFileIcon.contentData = null;
        self.errorMessage = "";
        let format = self.currentFileIcon.type.split("/");
        let reader = new FileReader();
        reader.onload = function (e) {
          try {
            let data = new Uint8Array(e.target.result);
            self.currentFileIcon.contentData = data;
            self.currentFileIcon.isValid = true;
            self.currentFileIcon.format = format[1];
          } catch (error) {
            window.self.errorMessage = error.message; //** console.log(error);
          } finally {
            self.$store.dispatch("stopLoader");
          }
        };
        reader.readAsArrayBuffer(self.currentFileIcon);
        console.log("currentFileIcon", self.currentFileIcon);
      }
    },

    // Carga el archivo en el bucket S3
    async doUploadPhoto(callback) {
      this.totalSteps = 0;
      this.completedSteps = 0;

      if (this.currentFile.isValid && this.currentFile.contentData) {
        let path = `${BASE_URL_FOR_PHOTOS}${uuid()}.${this.currentFile.format}`;
        console.log("Content id:" + path);
        return this.$Storage
          .put(
            path,
            this.currentFile.contentData,
            this.uploadProgressCallback,
            () => {
              return callback(path);
            }
          )
          .then(() => {
            console.log("archivo subido con exito a s3");
          })
          .catch(() => {
            console.log("error al subir archivo  a s3");
          });
      } else {
        throw new Error("Invalid file");
      }
    },
    async doUploadIco(callback) {
      this.totalSteps = 0;
      this.completedSteps = 0;

      if (this.currentFileIcon.isValid && this.currentFileIcon.contentData) {
        let path = `${BASE_URL_FOR_PHOTOS}${uuid()}.${
          this.currentFileIcon.format
        }`;
        console.log("Content id:" + path);
        return this.$Storage
          .put(
            path,
            this.currentFileIcon.contentData,
            this.uploadProgressCallback,
            () => {
              return callback(path);
            }
          )
          .then(() => {
            console.log("archivo subido con exito a s3");
          })
          .catch(() => {
            console.log("error al subir archivo  a s3");
          });
      } else {
        throw new Error("Invalid file");
      }
    },
    // Progess callback
    uploadProgressCallback(progress) {
      this.progress = Math.ceil((progress.loaded / progress.total) * 100);
      /* console.log(
        `Uploaded: ${progress.loaded}/${progress.total}  ${this.progress}%`
      );*/
    },
  },
};
</script>